import {
  UserState,
  REQUEST_USER_ORDERS,
  REQUEST_ADMINS,
  UserActionTypes,
  UserOrdersState,
  REQUEST_USERS
} from "./types";

const initialPeopleState: UserState = {
  isLoading: true,
  admins: [],
  users: []
};

const initialUserOrdersState: UserOrdersState = {
  userOrders: []
};

export function userReducer(
  state = initialPeopleState,
  action: UserActionTypes
) {
  switch (action.type) {
    case REQUEST_ADMINS:
      return { ...state, admins: action.payload };
    case REQUEST_USERS:
      return { ...state, users: action.payload, isLoading: false };
    default:
      return state;
  }
}

export function userOrdersReducer(
  state = initialUserOrdersState,
  action: UserActionTypes
) {
  switch (action.type) {
    case REQUEST_USER_ORDERS:
      return action.payload;
    default:
      return state;
  }
}
